import React from 'react';

// import { Container } from './styles';

import { Colors } from '../../styles/constants';

import Button from '../Button';

import {
  STATUS_AGENDA,
  STATUS_TELEATENDIMENTO_STRING,
} from '../../utils/funcoes';
import { useAuth } from '../../hooks/auth';
import {
  IListaAgendamentosTeleatendimentoDTO,
  IMudarStatus,
} from '../../pages/AgendaTeleAtendimento';

const teleStatusConfig: {
  [key: number]: { bg: string; text: string; dot: string };
} = {
  1: { bg: '#e2e3e5', text: '#383d41', dot: '#6c757d' },
  2: { bg: '#cce5ff', text: '#004085', dot: '#007bff' },
  3: { bg: '#fff3cd', text: '#856404', dot: '#ffc107' },
  4: { bg: '#d4edda', text: '#14532d', dot: '#28a745' },
  5: { bg: '#e2d5f7', text: '#5b2c9f', dot: '#8031f7' },
  6: { bg: '#cff4fc', text: '#055160', dot: '#17a2b8' },
  7: { bg: '#d1e7dd', text: '#0f5132', dot: '#198754' },
};

type listaProps = {
  listaEspera: IListaAgendamentosTeleatendimentoDTO[];
  dadosBusca: {
    dataAgenda: string;
    codigoAgenda: string | undefined;
    somenteLista: boolean;
  };
  mudarStatus(dados: IMudarStatus): void;
  abrirHistorico(pacCodigo: number): void;
  abrirAtendimento(AgeCodigo: number, urlVideo: string): void;
  exibeBotoesAcao?: boolean;
};
const ListaTeleAtendimento: React.FC<listaProps> = ({
  listaEspera,
  dadosBusca,
  mudarStatus,
  abrirHistorico,
  abrirAtendimento,
  exibeBotoesAcao = true,
}) => {
  const { user, clinica } = useAuth();
  console.log(listaEspera);
  return (
    <>
      {listaEspera && listaEspera.length > 0 ? (
        <table
          className="table table-hover table-sm table-font-small"
          style={{ borderWidth: '0px' }}
        >
          <thead>
            <tr className="bg-light" style={{ fontSize: 'Small' }}>
              <th scope="col">&nbsp;</th>
              <th scope="col">Horário</th>
              <th scope="col">Entrou às</th>
              <th scope="col">Paciente</th>
              <th scope="col">Celular</th>
              <th scope="col">Agenda</th>
              {(exibeBotoesAcao || clinica.CliUsaPainel) && (
                <th scope="col">Ação</th>
              )}
            </tr>
          </thead>
          <tbody>
            {listaEspera.map((lista: IListaAgendamentosTeleatendimentoDTO) => (
              <tr
                key={lista.AgeCodigo}
                style={{
                  fontSize: 'Small',
                  height: '30px',
                  color:
                    lista.AgeStatus === STATUS_AGENDA.ATENDIDO
                      ? Colors.success
                      : '#000',
                }}
                className={`bg-light `}
              >
                <td
                  style={{
                    width: '230px',

                    textAlign: 'center',
                  }}
                >
                  {(() => {
                    if (lista.statusTelemedicina > 0) {
                      const status =
                        teleStatusConfig[lista.statusTelemedicina] ??
                        teleStatusConfig[1];
                      return (
                        <div
                          style={{
                            display: 'flex',
                            width: '100%',
                            flexDirection: 'row',
                            justifyContent: 'center',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              backgroundColor: status.bg,
                              flexDirection: 'row',
                              alignItems: 'center',
                              padding: '4px 10px',
                              borderRadius: '10px',
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: status.dot,
                                borderRadius: '9999px',
                                width: '8px',
                                height: '8px',
                              }}
                            />
                            <span
                              style={{
                                color: status.text,
                                paddingLeft: '10px',
                              }}
                            >
                              {
                                STATUS_TELEATENDIMENTO_STRING[
                                  lista.statusTelemedicina
                                ]
                              }
                            </span>
                          </div>
                        </div>
                      );
                    }
                    return <></>;
                  })()}
                </td>
                <td style={{ width: '80px' }}>{lista.horario}</td>
                <td style={{ width: '80px' }}>{lista.dataEntrada}</td>
                <td>
                  {/* {lista.PacNome.trim() !== ''
                    ? `Nome Social: ${lista.PacNomeSocial} - ${lista.PacNome}`
                    : lista.PacNome} */}

                  {lista.PacNome}
                </td>

                <td style={{ width: '120px' }}>
                  {`${lista.celular || lista.PacCelular}`}
                </td>
                <td>
                  {lista.PerNome} - {lista.medico}
                </td>
                <td>
                  <>
                    {lista.statusTelemedicina.toString() === '1' && (
                      <Button
                        type="button"
                        variant="primary-outline"
                        className="py-0"
                        style={{ height: '23px' }}
                        onClick={() => {
                          mudarStatus({
                            AgeCodigo: lista.AgeCodigo,
                            AgeChave: lista.AgeChave,
                            status: Number(lista.statusTelemedicina) + 1,
                          });
                        }}
                      >
                        Realizar Pré-Atendimento
                      </Button>
                    )}

                    {lista.statusTelemedicina.toString() === '2' &&
                      user.UsuCodigo.toString() ===
                        lista.statusUsuario.toString() && (
                        <Button
                          type="button"
                          variant="primary-outline"
                          className={`py-0 `}
                          style={{ height: '23px' }}
                          onClick={() => {
                            abrirAtendimento(
                              lista.AgeCodigo,
                              lista.urlVideo || '',
                            );
                          }}
                        >
                          Abrir Pré-Atendimento
                        </Button>
                      )}

                    {lista.statusTelemedicina.toString() === '5' && (
                      <Button
                        type="button"
                        variant="primary-outline"
                        className={`py-0 `}
                        style={{ height: '23px' }}
                        onClick={() => {
                          mudarStatus({
                            AgeCodigo: lista.AgeCodigo,
                            AgeChave: lista.AgeChave,
                            status: Number(lista.statusTelemedicina) + 1,
                          });
                        }}
                      >
                        Realizar Pós-Atendimento
                      </Button>
                    )}

                    {lista.statusTelemedicina.toString() === '6' &&
                      user.UsuCodigo.toString() ===
                        lista.statusUsuario.toString() && (
                        <Button
                          type="button"
                          variant="primary-outline"
                          className={`py-0 `}
                          style={{ height: '23px' }}
                          onClick={() => {
                            abrirAtendimento(
                              lista.AgeCodigo,
                              lista.urlVideo || '',
                            );
                          }}
                        >
                          Abrir Pós-Atendimento
                        </Button>
                      )}

                    <Button
                      type="button"
                      variant="primary"
                      className="py-0 ml-2"
                      style={{ height: '23px' }}
                      onClick={() => abrirHistorico(lista.PacCodigo)}
                      title={lista.PacCodigo.toString()}
                    >
                      Histórico
                    </Button>
                  </>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '5%',
          }}
        >
          <span>
            <h3>Sem Pacientes de teleatendimento</h3>
          </span>
        </div>
      )}
    </>
  );
};
export default ListaTeleAtendimento;
